import { faker } from '@faker-js/faker'

import { isObject, randomIntegerInRange } from './utils'

export enum PaymentMethod {
  CASH = 'CASH',
  CHECK = 'CHECK',
  CREDIT_CARD = 'CREDIT_CARD',
  ACH = 'ACH',
  CREDIT_BALANCE = 'CREDIT_BALANCE',
  OTHER = 'OTHER',
}

export enum PaymentProcessor {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
  SHOPIFY = 'SHOPIFY',
  ADYEN = 'ADYEN',
  RAINFOREST = 'RAINFOREST',
  PROCESSOR = 'PROCESSOR', // For demo
}

export type PaymentTag = {
  key: string
  value: string
}

export type Payment = {
  external_id?: string
  processor?: PaymentProcessor
  method: PaymentMethod
  fee: number
  amount: number
  tags?: PaymentTag[]
}

export const validatePayment = (payment: unknown): payment is Payment => {
  return (
    isObject(payment)
    && 'method' in payment
    && typeof payment.method === 'string'
    && 'fee' in payment
    && typeof payment.fee === 'number'
    && 'amount' in payment
    && typeof payment.amount === 'number'
  )
}

export const generatePayment = (overrides?: Partial<Payment>): Payment => {
  const method = faker.helpers.arrayElement(
    Object.values(PaymentMethod),
  ) as PaymentMethod

  return {
    method,
    amount: randomIntegerInRange(1000, 100000),
    fee: 0,
    ...overrides,
  }
}
